import { DirectorRemunerationStatus } from '@enums/director-remuneration-status.enum';

export const DIRECTOR_REMUNERATION_STATUS_LABEL: Record<DirectorRemunerationStatus, string> = {
  [DirectorRemunerationStatus.ignored]: 'Ignoré',
  [DirectorRemunerationStatus.done]: 'Terminé',
  [DirectorRemunerationStatus.readyToBeSent]: 'À envoyer',
  [DirectorRemunerationStatus.sent]: 'Envoyé',
  [DirectorRemunerationStatus.todo]: 'À faire',
  [DirectorRemunerationStatus.toCheck]: 'À vérifier'
};
